"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fabric_1 = require("@aperza/fabric");
var util_1 = require("@aperza/util");
exports.createDate = function (_a) {
    var companyName = _a.companyName, dateFormat = _a.dateFormat, userName = _a.userName;
    var _b, _c;
    //// numbers you can change
    var buttonSize = 100;
    var upness = 3; // how far up the circle to put the horizontal bar  3 => 1/3
    var maxTextWidth = 59;
    ///////
    var radiusStrokeWidth = buttonSize / 50;
    var otherStrokeWidth = buttonSize / 100;
    var buttonCenter = buttonSize / 2;
    var radius = buttonCenter - radiusStrokeWidth / 2;
    var outerCircle = new fabric_1.fabric.Circle({
        originX: 'center',
        originY: 'center',
        stroke: 'red',
        fill: 'rgba(0,0,0,0)',
        radius: radius,
        strokeWidth: radiusStrokeWidth,
        left: buttonCenter,
        top: buttonCenter,
    });
    var yTopOrigin0 = radius / upness;
    var yBottomOrigin0 = -(radius / upness);
    var xLeftOrigin0 = -Math.sqrt(Math.pow(radius, 2) - Math.pow(yTopOrigin0, 2)); // x^2 = r^2 - y^2
    var xRightOrigin0 = -xLeftOrigin0;
    var xLeft = xLeftOrigin0 + buttonCenter;
    var xRight = xRightOrigin0 + buttonCenter;
    var yTop = buttonCenter - yTopOrigin0; // because coordinate system is flipped
    var yBottom = buttonCenter - yBottomOrigin0;
    var topBar = new fabric_1.fabric.Path("M " + xLeft + " " + yTop + " L " + xRight + " " + yTop + " z");
    topBar.set({
        strokeWidth: otherStrokeWidth,
        stroke: 'red',
    });
    var bottomBar = new fabric_1.fabric.Path("M " + xLeft + " " + yBottom + " L " + xRight + " " + yBottom + " z");
    bottomBar.set({
        strokeWidth: otherStrokeWidth,
        stroke: 'red',
    });
    var companyNameTextObject = new fabric_1.fabric.Text(companyName, {
        originX: 'center',
        originY: 'center',
        left: buttonCenter,
        top: yTop / 1.5,
        stroke: 'red',
        strokeWidth: otherStrokeWidth,
        fill: 'red',
        fontSize: (15 / 100) * buttonSize,
        fontFamily: 'Helvetica',
    });
    if ((_b = companyNameTextObject === null || companyNameTextObject === void 0 ? void 0 : companyNameTextObject.text) === null || _b === void 0 ? void 0 : _b.length) {
        // scale text smaller if many characters
        var targetWidthCompanyName = ((maxTextWidth + companyNameTextObject.text.length - 4) * buttonSize) / 100;
        if (companyNameTextObject === null || companyNameTextObject === void 0 ? void 0 : companyNameTextObject.width) {
            if (companyNameTextObject.width > targetWidthCompanyName) {
                var scaleCompanyName = targetWidthCompanyName / companyNameTextObject.width;
                companyNameTextObject.scale(scaleCompanyName);
            }
        }
    }
    var dateText = util_1.DateUtil.format(new Date(), dateFormat);
    var dateTextObject = new fabric_1.fabric.Text(dateText, {
        originX: 'center',
        originY: 'center',
        left: buttonCenter,
        top: buttonCenter + 1,
        stroke: 'red',
        strokeWidth: otherStrokeWidth,
        fill: 'red',
        fontSize: buttonSize / 5,
        fontFamily: 'Helvetica',
    });
    var shiftUp = (Math.max(userName.length - 4, 0) / 4) * 0.2; // shift text up if text has more characters and is smaller
    var userNameTextObject = new fabric_1.fabric.Text(userName, {
        originX: 'center',
        originY: 'center',
        left: buttonCenter,
        top: yBottom + yTop - yTop / (1.7 - shiftUp),
        stroke: 'red',
        strokeWidth: otherStrokeWidth,
        fill: 'red',
        fontSize: (15 / 100) * buttonSize,
        fontFamily: 'Helvetica',
    });
    if ((_c = userNameTextObject === null || userNameTextObject === void 0 ? void 0 : userNameTextObject.text) === null || _c === void 0 ? void 0 : _c.length) {
        // scale text smaller if many characters
        var targetWidthUserName = ((maxTextWidth + userNameTextObject.text.length - 4) * buttonSize) / 100;
        if (userNameTextObject === null || userNameTextObject === void 0 ? void 0 : userNameTextObject.width) {
            if (userNameTextObject.width > targetWidthUserName) {
                var scaleUserName = targetWidthUserName / (userNameTextObject.width || targetWidthUserName);
                userNameTextObject.scale(scaleUserName);
            }
        }
    }
    var fabricGroup = new fabric_1.fabric.Group([
        outerCircle,
        topBar,
        bottomBar,
        companyNameTextObject,
        dateTextObject,
        userNameTextObject,
    ]);
    return fabricGroup;
};
//# sourceMappingURL=CreateDate.js.map